import React from 'react'

import { Wrapper } from './Rgpd.style'

const Rgpd = () => (
  <Wrapper>
    En cliquant sur &#34;Obtenir mes devis de déménageurs&#34;, vous acceptez nos <a href="/Conditions_Generales_d_Utilisation.html">Conditions Générales d’Utilisation.</a> Digital
    Classifieds France procède au traitement de vos données afin de transmettre votre demande de devis de déménagement à notre partenaire, Nextories. Ces données pourront être
    transmises aux sociétés du <a href="https://www.aviv-group.com/companies">Groupe AVIV</a> auquel nous appartenons. Pour obtenir plus d&#39; informations sur vos droits et sur
    vos données, consultez notre <a href="/CGU_politique_de_confidentialite.html">Politique de Confidentialité.</a>
  </Wrapper>
)

export default Rgpd
